// extracted by mini-css-extract-plugin
export var card = "CompletedCard-module--card--f0b63";
export var container = "CompletedCard-module--container--fd51f";
export var heading = "CompletedCard-module--heading--e3cb7";